import { render, staticRenderFns } from "./EmailDispatchDocumentForm.vue?vue&type=template&id=50adce7e&scoped=true"
import script from "./EmailDispatchDocumentForm.vue?vue&type=script&lang=js"
export * from "./EmailDispatchDocumentForm.vue?vue&type=script&lang=js"
import style0 from "./EmailDispatchDocumentForm.vue?vue&type=style&index=0&id=50adce7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50adce7e",
  null
  
)

export default component.exports